import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';

export class FetchPATrendLogsCommand<T> extends GetAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>, patientId: number, type: string) {
    super(
      apiService,
      adapter,
      `${environment.patientApiUrl}/patients-physical-activity/${patientId}/${type}`,
    );
  }
}
